import {useState} from "react";
import {DownIcon, UpICon, URLLinkIcon} from "..";
import {ContactProps} from "./Decription.Modal.props";
import {DesContent, Div, PHeader, ToggleButton} from "./Description.styled";
import { OFFERING_TYPE } from "../../../utils/constant";

const ServiceDescriptionModal = ({bodyContent, data,tab, industyData}: ContactProps) => {
  const [isShowMore, setIsModalOneOpen] = useState(false);

  const TextComponent = (text: string) => {
    const formattedText = text.length > 300 ? text.substring(0, 300) + "..." : text;
    return <div>{formattedText}</div>;
  };
  return (
    <Div className="des-container">
      {data && (
        <>
          {tab === "product" && data.title ? (
            <div className={`text-[1.1875rem] font-[700] text-[#333333] ${data.fkOfferingTypeId === OFFERING_TYPE.PRODUCT ? `pb-[15px]`:`pb-[5px]`}`}>
              <p>{data.title} </p>
            </div>
          ) : null}
          {data?.urlLink ? (
            <div className={`firm-url flex`}>
              <>
                <div>
                  <URLLinkIcon />
                </div>
                <a
                  className="text-[14px] flex font-[700] text-[#333333] items-center justify-center leading-[16.41px] underline decoration-1"
                  href={data?.urlLink}
                >
                  {data?.webpageDisplayName ? data?.webpageDisplayName : "Organization Webpage"}
                </a>
              </>
            </div>
          ) : null}
          {data.tagLine && (
            <DesContent className={`service-description ${!data.urlLink ? `pt-[10px]` : `pt-[20px]`}`}>{data.tagLine}</DesContent>
          )}
          {data.highLevelPitch && (
            <DesContent className={`service-description ${!data.urlLink ? `pt-[10px]` : `pt-[20px]`}`}>{data.highLevelPitch}</DesContent>
          )}
          {data.detailedDescription && (
            <DesContent className={`service-description ${!data.urlLink ? `pt-[10px]` : `pt-[20px]`}`}>
              {data.detailedDescription}
            </DesContent>
          )}
        </>
      )}
    </Div>
  );
};

export default ServiceDescriptionModal;
